import React from 'react'
import * as S from '../style'
import SelectHeatNumberInCertificate from '../../../../../components/Certificates/SelectItem/HeatNumber'
import SelectMaterialInCertificate from '../../../../../components/Certificates/SelectItem/Material'
import { CertificateType } from '..'
import { Input } from '../../../../../components/styles/select-style'

interface PropsType {
  certificate: CertificateType
  setCertificate: React.Dispatch<React.SetStateAction<CertificateType>>
}

const HeaderFields:React.FC<PropsType> = ({certificate, setCertificate}) => {
  const itsOurs = certificate.supplier?.isMain === true
  
  return (
    <S.StructureContainer>
      <S.HeaderFieldsContainer>
        <SelectHeatNumberInCertificate certificate={certificate} setCertificate={setCertificate} itsOurs={itsOurs} />
        <SelectMaterialInCertificate certificate={certificate} setCertificate={setCertificate} itsOurs={!itsOurs} />
        <S.InputDiv>
          <S.Label>Descrição</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.description || ''}
            onChange={(e) => setCertificate(prev => ({...prev, description:e.target.value}))}
          />
          </S.InputDiv>
        <S.InputDiv>
          <S.Label>Nota fiscal</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.invoiceNumber || ''}
            onChange={(e) => setCertificate(prev => ({...prev, invoiceNumber:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Norma</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.standard || ''}
            onChange={(e) => setCertificate(prev => ({...prev, standard:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Tratamento térmico</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.heatTreatment || ''}
            onChange={(e) => setCertificate(prev => ({...prev, heatTreatment:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Nº do pedido de compra</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.purchaseOrderNumber || ''}
            onChange={(e) => setCertificate(prev => ({...prev, purchaseOrderNumber:e.target.value}))}
          />
        </S.InputDiv>
        <S.InputDiv>
          <S.Label>Observações</S.Label>
          <Input 
            placeholder='Digite aqui'
            disabled={!itsOurs}
            value={certificate.observations || ''}
            onChange={(e) => setCertificate(prev => ({...prev, observations:e.target.value}))}
          />
        </S.InputDiv>
      </S.HeaderFieldsContainer>
    </S.StructureContainer>
  )
}

export default HeaderFields